import render from 'preact-render-to-string';
import { Link, route } from 'preact-router';
import Table from "../components/ui/Table";
import useApp from '../context/AppContext';

export default function CategoriesList() {
    const { categories, events } = useApp();
    const columns = [
        { label: "Nom", accessor: "name", sortable: false },
        { label: "Nombre d'évènements", accessor: "nb_evt", sortable: false },
    ];

    function cellFormat(value, accessor, data) {
        let str = value;
        switch (accessor) {
            case 'name':
                str = render(<Link href={'/form-category/' + data.id}>{value}</Link>);
                break;
            case 'nb_evt':
                str = events.filter(evt => evt.categoryId == data.id).length;
                break;

            default:
                break;
        }
        return str;
    }

    function onClick() {
        route('/form-category');
    }

    if (typeof categories == 'undefined' || categories === null) {
        return <div className="text-center pt-5">Loading categories ...</div>;
    }

    return (
        <div>
            <Table id="categories" caption="Liste des catégories" columns={columns} selectable={false} cellFormat={cellFormat} data={categories} />
            <input class="action-button btn btn-primary position-fixed bottom-0 end-0 me-3 mb-3" type="button" value="Ajouter une catégorie" onClick={onClick} />
        </div>
    );
}